import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { InViewTracking } from './InViewTracking';

export default createBuilderModule(withChildren(InViewTracking), {
  name: 'InViewTracking',
  image: 'https://cdn.zappy.app/a26168b9b480805722e50990a838c47c.png',
  description: 'DO NOT USE THIS ON ANY SECTION COMPONENTS',
  inputs: [
    {
      name: 'sectionName',
      helperText:
        'DO NOT USE THIS COMPONENT WITH SECTION COMPONENTS OR YOU WILL GET DOUBLE TRACKING',
      type: 'string',
      required: true,
    },
  ],
});
